module.exports = [{"value":""},{"value":"agency@kudratmalaysia.com"}]


//////////////////
// WEBPACK FOOTER
// ./src/Controls/Select/DataPDBAgentCompany.json
// module id = 7642
// module chunks = 21